import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(5),
        paddingTop: theme.spacing(3),
    },
    content: {
        textAlign: 'center',
        marginTop: theme.spacing(7),
        marginBottom: theme.spacing(3),
    },
    link: {
        color: '#94C11F'
    },
}));

function PlanSite() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography variant="h1" className={classes.content}>
                Plan du site
            </Typography>
            <Typography variant="caption" gutterBottom>Date de la dernière modification : 20 juillet 2021</Typography>
            <br/>
            <br/>
            <Typography variant="h2" gutterBottom>Pages</Typography>
            <ul>
                <Typography component={'li'} variant={"subtitle2"} gutterBottom>
                    <a href="https://www.cyklad.fr/" className={classes.link}>Accueil</a>
                </Typography>
                <Typography component={'li'} variant={"subtitle2"} gutterBottom>
                    <a href="https://www.cyklad.fr/pourquoi-cyklad" className={classes.link}>Pourquoi Cyklad ?</a>
                </Typography>
                <Typography component={'li'} variant={"subtitle2"} gutterBottom>
                    <a href="https://www.cyklad.fr/services" className={classes.link}>Offre de services</a>
                </Typography>
                <Typography component={'li'} variant={"subtitle2"} gutterBottom>
                    <a href="https://www.cyklad.fr/mention-legale" className={classes.link}>Mentions Légales</a>
                </Typography>
                <Typography component={'li'} variant={"subtitle2"} gutterBottom>
                    <a href="https://www.cyklad.fr/cookies" className={classes.link}>Cookies</a>
                </Typography>
                <Typography component={'li'} variant={"subtitle2"} gutterBottom>
                    <a href="https://www.cyklad.fr/conditions-utilisation"
                       className={classes.link}>Conditions d'Utilisation</a>
                </Typography>
            </ul>
        </div>
    )
}

export default PlanSite